<template>
  <li class="recipe">
    <a @click="goToRoute()">
      <div class="image">
        <img :src="`/image/recipe${id}.jpg`" alt="" />
        <button class="playButton" v-if="hasVideo">
          <img src="../../assets/play.svg" alt="" />
        </button>
      </div>
      <h2 class="title">{{ title }}</h2>
      <dl class="content">
        <dd class="persons" v-if="persons"><span>Recept voor:</span> {{ persons }}</dd>
        <dd class="cookingTime" v-if="cookingTime"><span>Kooktijd:</span> {{ cookingTime }}</dd>
        <dd class="prepTime" v-if="prepTime"><span>Voorbereidingstijd:</span> {{ prepTime }}</dd>
      </dl>
    </a>
  </li>
</template>
<script>
/* eslint-disable no-useless-escape */

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    persons: {
      type: String,
      default: '',
    },
    cookingTime: {
      type: String,
      default: '',
    },
    prepTime: {
      type: String,
      default: '',
    },
    hasVideo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    goToRoute() {
      const title = this.slugify(this.title);
      this.$router.push({ path: `/recept/${this.id}/${title}` });
    },
    slugify(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
    },
  },
};
</script>
<style lang="scss" scoped>
.recipe {
  width: 100%;
  list-style-type: none;
  text-align: left;
  margin: 0 0 30px 0;

  a {
    cursor: pointer;
  }
}

.image {
  width: 80%;
  margin: 0 0 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
  @include tablet {
    width: 100%;
  }
}

.playButton {
  position: absolute;
}

h2.title {
  font-family: $national-condensed-bold;
  font-size: 25px;
  color: #000000;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  @include tablet {
    font-size: 30px;
  }
}

dl.content {
  padding: 0;
  margin: 0;

  dd {
    margin: 0;
    font-family: $national-condensed;
    list-style-type: none;
    font-size: 16px;
    color: #000000;
    line-height: 18px;
    @include tablet {
      font-size: 18px;
      line-height: 24px;
    }

    span {
      font-family: $national-condensed-bold;
      text-transform: uppercase;
    }
  }
}
</style>
